import * as sync from './sync';
import * as async from './async';


export default { ...sync, ...async };



// WEBPACK FOOTER //
// ./src/actions/index.js